import { EEbiFormCategory, EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * G5. Wniosek o wydanie pozwolenia wodnoprawnego — art. 388–389, 397–398 i 407–409 ustawy z 20.07.2017 r. — Prawo wodne.
 * Sprawa poza właściwością starostwa (od 1.01.2018 r. organami są dyrektor zarządu zlewni albo dyrektor RZGW Wód
 * Polskich), więc katalog tylko odsyła: strona usługi Wód Polskich z wzorem wniosku
 * https://www.gov.pl/web/wody-polskie/pozwolenie-wodnoprawne (pobrana 22.10.2026 — miejsce złożenia, dokumenty, opłata
 * 330,07 zł). Składanie przez skrzynkę ePUAP nadzoru wodnego — według opisu usługi na biznes.gov.pl (ou77) z katalogu.
 */
const G5: IEbiFormDefinition = {
  code: "G5",
  version: 1,
  title: "Wniosek o wydanie pozwolenia wodnoprawnego",
  category: EEbiFormCategory.Environment,
  office: EEbiFormOffice.County,
  description: "Pozwolenie wodnoprawne wydają Wody Polskie — wniosek składa się w nadzorze wodnym, nie w starostwie.",
  keywords: ["pozwolenie wodnoprawne", "wody polskie", "nadzór wodny", "operat wodnoprawny", "zgoda wodnoprawna", "studnia", "ścieki"],
  organ: "Państwowe Gospodarstwo Wodne Wody Polskie — dyrektor zarządu zlewni albo dyrektor regionalnego zarządu gospodarki wodnej",
  legalBasis: "art. 388, art. 397, art. 398 i art. 407 ustawy z dnia 20 lipca 2017 r. — Prawo wodne",
  fee: "330,07 zł za wydanie pozwolenia (stawka na 2026 r., wielokrotność przy kilku pozwoleniach w jednej decyzji) — na rachunek Wód Polskich; pełnomocnictwo — 17 zł.",
  deadline: "Do miesiąca, w szczególnych przypadkach do 2 miesięcy.",
  external: {
    service: "Wody Polskie — nadzór wodny",
    url: "https://www.gov.pl/web/wody-polskie/pozwolenie-wodnoprawne",
    text: "Pozwolenie wodnoprawne wydaje Państwowe Gospodarstwo Wodne Wody Polskie, a nie starosta. Wniosek na wzorze Wód Polskich złóż w nadzorze wodnym właściwym dla miejsca inwestycji — osobiście, pocztą albo elektronicznie przez jego skrzynkę ePUAP. Przygotuj operat wodnoprawny (wersja papierowa i elektroniczna), wypisy z rejestru gruntów dla nieruchomości w zasięgu oddziaływania (możesz o nie wystąpić w starostwie — wniosek G1) oraz dowód opłaty za pozwolenie.",
  },
  sections: [],
  attachments: [],
};

export default G5;
